/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { chevronDown } from "../assets/chevron-down";
import { Icon, type IconBaseProps } from "../icon";

export const IconChevronDown = (props: IconBaseProps) => <Icon {...props} svg={chevronDown} />;

IconChevronDown.displayName = "IconChevronDown";
